export default {
	computed: {
		oppositeInsuranceStatus() {
			return [
				{
					display: this.$t('insurance_known'),
					value: 'versicherung_bekannt',
				},
				{
					display: this.$t('private_liability'),
					value: 'privater_haftpflichtschaden',
				},
				{
					display: this.$t('private_liability_opponent_without_insurance'),
					value: 'privater_haftpflichtschaden_ohne_versicherung',
				},
				{
					display: this.$t('insurance_unknown'),
					value: 'versicherung_unbekannt',
				},
				{
					display: this.$t('abroad_insurance_office'),
					value: 'auslaendischer_versicherer',
				},
			];
		},
		comprehensiveOppositeInsuranceStatus() {
			return [
				{
					display: this.$t('insurance_known'),
					value: 'versicherung_bekannt',
				},
				{
					display: this.$t('without_insurance_self_paid'),
					value: 'ohne_versicherung_selbstzahler',
				},
			];
		},
	},
};
